import { fork } from "redux-saga/effects";
import { watchApprovalSaga } from "./approval";
import { watchSignatureSaga } from "./signature";

export function* rootSaga() {
    yield fork(watchSignatureSaga);
    yield fork(watchApprovalSaga);
}
